<template>
  <div :class="`price-card ${$i18n.locale}`">
    <div class="card-content">
      <div class="price-text previous">
        <span class="price">{{ $t('study-abroad.price.previous') }}</span>
        <span class="period">{{ $t('study-abroad.price.per') }}</span>
      </div>
      <img src="/img/lp/lpIconArrow.png" alt="[Arrow]" class="img-arrow" />
      <div class="price-text current">
        <span class="price">{{ currentPrice }}</span>
        <span class="period">{{ $t('study-abroad.price.per') }}</span>
      </div>
      <div class="card-underline"></div>
      <div class="price-hint">{{ $t('study-abroad.price.hint') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['programKey'],

  data() {
    let currentPrice = '';
    if (['mayu', 'homin'].includes(this.programKey)) {
      currentPrice = this.$t('study-abroad.price.current-salon');
    } else {
      currentPrice = this.$t('study-abroad.price.current');
    }

    return {
      currentPrice: currentPrice,
    };
  },
};
</script>

<style scoped>
.price-card {
  width: 1000px;
  margin: 0 auto;
  background-color: rgba(66, 132, 55, 0.7);
  border-radius: 6px;
  padding: 28px 0px 14px;
  color: #fff;
}
.card-content {
  width: max-content;
  margin: 0 auto;
}
.price-text {
  display: inline-block;
  vertical-align: bottom;
  font-weight: bold;
  line-height: 1;
}
.price-text.previous .price {
  font-size: 45px;
  padding: 0 10px;
  position: relative;
}
.price-text.previous .price:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 20px;
  background-color: rgb(255, 66, 66);
  height: 6px;
  border-radius: 3px;
  transform: rotate(-8deg);
}
.price-text.previous .period,
.price-text.current .period {
  font-size: 28px;
}
.price-text.current .price {
  font-size: 65px;
  margin-right: 12px;
}
.img-arrow {
  margin: 4px 24px 0 28px;
  vertical-align: top;
}
.card-underline {
  border-radius: 1px;
  background-color: rgb(255, 241, 9);
  height: 6px;
  margin-top: 12px;
}
.price-hint {
  font-size: 22px;
  font-weight: bold;
  white-space: pre-wrap;
  margin-top: 8px;
  line-height: 1.3em;
}
@media (max-width: 1023px) {
  .price-card {
    width: 700px;
  }
  .price-text.previous .price {
    font-size: 32px;
  }
  .price-card.id .price-text.previous .price {
    font-size: 30px;
  }
  .price-card.id .price-text.previous .price:before {
    top: 14px;
  }
  .price-text.previous .period,
  .price-text.current .period {
    font-size: 18px;
  }
  .price-card.id .price-text.previous .period,
  .price-card.id .price-text.current .period {
    font-size: 16px;
  }
  .price-text.current .price {
    font-size: 46px;
  }
  .price-card.id .price-text.current .price {
    font-size: 44px;
  }
  .price-card.id .img-arrow {
    width: 20px;
    margin: 3px 20px 0 22px;
  }
  .card-underline {
    margin-top: 6px;
  }
  .price-hint {
    font-size: 18px;
  }
}
@media (max-width: 767px) {
  .price-card {
    width: 350px;
    padding: 14px 0px 7px;
  }
  .price-text.previous .price {
    font-size: 23px;
    padding: 0 5px;
  }
  .price-card.id .price-text.previous .price {
    font-size: 16px;
  }
  .price-card.id .price-text.previous .price:before {
    top: 7px;
  }
  .price-text.previous .price:before {
    top: 9px;
    height: 3px;
  }
  .price-text.previous .period,
  .price-text.current .period {
    font-size: 14px;
  }
  .price-card.id .price-text.previous .period,
  .price-card.id .price-text.current .period {
    font-size: 10px;
  }
  .price-text.current .price {
    font-size: 32px;
    margin-right: 6px;
  }
  .price-card.id .price-text.current .price {
    font-size: 20px;
    margin-right: 2px;
  }
  .img-arrow {
    width: 16px;
    margin: 2px 12px 0;
  }
  .price-card.id .img-arrow {
    width: 10px;
    margin: 2px 6px 0;
  }
  .card-underline {
    margin-top: 4px;
    height: 3px;
  }
  .price-hint {
    font-size: 10px;
    margin-top: 4px;
  }
}
@media (max-width: 360px) {
  .price-card {
    width: 300px;
  }
  .price-card.id {
    padding-top: 8px;
  }
  .price-text.previous .price {
    font-size: 20px;
    padding: 0 2px;
  }
  .price-card.id .price-text.previous .price {
    font-size: 14px;
  }
  .price-card.id .price-text.previous .price:before {
    top: 6px;
  }
  .price-text.previous .period,
  .price-text.current .period {
    font-size: 12px;
  }
  .price-text.current .price {
    font-size: 28px;
    margin-right: 3px;
  }
  .price-card.id .price-text.current .price {
    font-size: 18px;
  }
  .img-arrow {
    width: 12px;
    margin: 2px 8px;
  }
}
</style>
